// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__distributionHeaderWrapper___pJDmw {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDull"]};
}

.styles__distributionHeader___S7N4V {
  display: flex;
  position: relative;
  flex-direction: row;
}

.styles__distributionHeaderLeft___fAOYJ {
  width: calc(99.9% * 3/4 - (30px - 30px * 3/4));
}

.styles__distributionHeaderLeft___fAOYJ:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__distributionHeaderLeft___fAOYJ:last-child {
  margin-right: 0;
}

.styles__distributionHeaderLeft___fAOYJ:nth-child(4n) {
  margin-right: 0;
  float: right;
}

.styles__distributionHeaderLeft___fAOYJ:nth-child(4n + 1) {
  clear: both;
}

.styles__distributionHeaderLeft___fAOYJ .styles__drfHeader___bHz5a {
    font-weight: 600;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    margin-bottom: 32px;
  }

.styles__distributionHeaderRight___n0Rqk {
  width: calc(99.9% * 1/4 - (30px - 30px * 1/4));
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.styles__distributionHeaderRight___n0Rqk:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__distributionHeaderRight___n0Rqk:last-child {
  margin-right: 0;
}

.styles__distributionHeaderRight___n0Rqk:nth-child(4n) {
  margin-right: 0;
  float: right;
}

.styles__distributionHeaderRight___n0Rqk:nth-child(4n + 1) {
  clear: both;
}

.styles__contentContainer___s91oN {
  display: flex;
  position: relative;
  flex-direction: column;
}

.styles__section___auDdN {
  margin-bottom: 20px;
  position: relative;
}

.styles__sectionTitle___Z8ObV {
  margin-top: 0;
  margin-bottom: 20px;
}

.styles__sectionSubtitle___nlm_Y {
  margin-top: 0;
}

/* BTE note: I don't know why this works but...CSS is weird. */
.styles__fullScreen___BOMKu {
  width: calc(99.9% * 3/3 - (30px - 30px * 3/3));
}
.styles__fullScreen___BOMKu:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__fullScreen___BOMKu:last-child {
  margin-right: 0;
}
.styles__fullScreen___BOMKu:nth-child(3n) {
  margin-right: 0;
  float: right;
}
.styles__fullScreen___BOMKu:nth-child(3n + 1) {
  clear: both;
}
@media only screen and (max-width: 768px) {
.styles__fullScreen___BOMKu {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}
.styles__fullScreen___BOMKu:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}
.styles__fullScreen___BOMKu:last-child {
    margin-right: 0;
}
.styles__fullScreen___BOMKu:nth-child(1n) {
    margin-right: 0;
    float: right;
}
.styles__fullScreen___BOMKu:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__tableContainer___KqSjd {
  width: 100%;
  margin-top: 0px;
}

.styles__sectionNoMargin___bfeGn {
}

.styles__sectionNoMargin___bfeGn h2 {
    margin-bottom: 20px;
  }

.styles__input___DI2pD {
}

.styles__select___IO5mK {
}

.styles__label___bvoMI {
}

.styles__tabsContainer___Mz5q3 {
  /* display: flex;
  flex-direction: column; */
  width: 100%;
  background-color: antiquewhite;
}

.react-tabs__tab--selected {
    font-weight: 600;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textGray"]};
    border-bottom: 3px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textGray"]} !important;
    margin-bottom: -3px;
    text-transform: uppercase;
  }

.react-tabs__tab {
    opacity: 1;
    height: 50px;
    cursor: pointer;
    padding: 16px 10px;
    text-transform: uppercase;
    font-size: 14px;
  }

.react-tabs__capitalize {
    text-transform: uppercase !important;
  }

.styles__tabList___cNOf9 {
  color: textLight;
  height: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-flow: wrap;
  list-style: none;
  border-bottom: 1px solid borderColor;
  margin: 1px 0 0 0;
  padding: 0;
  position: relative;
  z-index: 10;
}

.styles__button___a55jA {
}

.styles__button___a55jA:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___igIw6 {
  margin-left: 8px;
}

.styles__buttonLocal___igIw6:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___igIw6.styles__disabled___RyW69 {
  display: none;
}

.styles__newRequestButton____kD85 {
  width: 100%;
  text-align: left;
}

.styles__headerDay___Hjv37 {
  margin-top: 28px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  margin-bottom: 0;
  font-weight: 300;
}

.styles__headerDate___pL9OI {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  font-weight: 700;
}

.styles__summaryBoxContainer___cgT8m {
  margin-top: 36px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.styles__summaryBox___NVDJZ {
  padding-left: 16px;
  margin-right: 16px;
  border-left: 1px solid rgba(128, 128, 128, 0.5);
  color: #31333f;
}

.styles__summaryBox___NVDJZ .styles__summaryBoxTitle___Whci6 {
    margin-bottom: 4px;
  }

.styles__summaryBox___NVDJZ .styles__summaryBoxCaption___IqiJB {
    margin: -4px 0 0 0;
    font-size: 10px;
  }

.styles__distributionHeaderNav___Aaw_G {
  display: flex;
  flex-direction: row;
  list-style: none;
  padding-left: 0;
  margin-bottom: 0 !important;
}

.styles__distributionHeaderNav___Aaw_G .styles__navItem___dZBpZ {
    font-size: 15px;
    font-weight: 500;
  }

.styles__distributionHeaderNav___Aaw_G .styles__navItem___dZBpZ:first-child {
      padding: 16px 25px 6px 0;
    }

.styles__distributionHeaderNav___Aaw_G .styles__navItem___dZBpZ:not(:first-child) {
      padding: 16px 25px 6px 25px;
    }

.styles__distributionHeaderNav___Aaw_G .styles__navItem___dZBpZ:hover {
      cursor: pointer;
    }

.styles__distributionHeaderNav___Aaw_G .styles__navItemActive___zsGun {
    margin-top: 1px;
    font-weight: 700;
    border-bottom: 3px solid;
  }

.styles__tableFilter___KfGrz {
  padding: 24px 18px;
}

.styles__tableFilter___KfGrz .styles__tableSelectFilter___HAwoo {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
  }

.styles__tableFilter___KfGrz .styles__tableSelectFilter___HAwoo .styles__tableSelect___Xtz0Y {
      width: 220px;
      margin-bottom: 12px;
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
    }

.styles__tableFilter___KfGrz .styles__tableSelectFilter___HAwoo p {
      color: white;
      font-weight: 600;
      -webkit-user-select: none;
              user-select: none;
      margin-top: 0 !important;
    }

.styles__tableFilter___KfGrz .styles__checkboxGroup___EVuBT {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    gap: 10px;
  }

.styles__tableFilter___KfGrz .styles__checkboxGroup___EVuBT > div {
    margin-bottom: 5px;
  }

.styles__tableFilter___KfGrz input[type='checkbox'] {
    position: absolute;
    left: -9999em;
  }

.styles__tableFilter___KfGrz label {
    display: block;
    padding: 6px 10px;
    box-sizing: border-box;
    border: 1px solid inherit;
    border-radius: 5px;
    background-color: transparent;
    font-size: 14px;
    cursor: pointer;
    position: relative;
  }

.styles__tableFilter___KfGrz .styles__checkboxActive___mhYk0 label {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
    font-weight: 700;
  }

.styles__tableFilter___KfGrz .styles__checkboxActiveInactive___HimYq label {
    border: 1px solid;
    background-color: transparent;
    /* Red for inactive state */
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
    /* White text for better visibility */
  }

.styles__tableHeader___ik3WO {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 6px !important;
  padding-top: 18px !important;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]} !important;
  color: #31333f !important;
  width: auto;
}

.styles__tableHeader___ik3WO span {
    align-items: center !important;
  }

.styles__cellNoPadding___VnitR {
  padding-right: 0 !important;
  width: 24px;
}

/* composes: formItemMono from helpers; */

.styles__formItemMono___mGC9T label {
    font-size: 12px;
  }

.styles__drfSearch___sotEN {
  display: flex;
  gap: 6px;
}

.styles__drfSearch___sotEN .styles__textInput___oV_xv {
    width: 100%;
    padding-left: 24px;
  }

.styles__capitalize___xheWF {
  text-transform: capitalize;
}

.styles__logo___mIZlx {
  height: 24px;
  width: 24px;
}

.styles__closingRow___jZTnV {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

.styles__closingRow___jZTnV .styles__tdCell___APNy0,
.styles__closingRow___jZTnV.styles__tdRow___AHnOw {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

.styles__closingRow___jZTnV .styles__tdCell___APNy0 span,
.styles__closingRow___jZTnV span {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

a.styles__closingRow___jZTnV {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

a.styles__closingRow___jZTnV .styles__tdCell___APNy0 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

a.styles__closingRow___jZTnV .styles__tdCell___APNy0 span {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]} !important;
}

.styles__exportLinkContainer___O64sG {
  padding: 12px 16px;
  text-align: right;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.styles__exportLink___LdBwA {
  background: none;
  border: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 8px;
  margin-left: auto;
  margin-right: 16px;
  height: 50px;
  display: flex;
  align-items: center;
}

.styles__exportLink___LdBwA:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/Queue/styles.css"],"names":[],"mappings":"AAIA;EACE,8DAA4B;AAC9B;;AAEA;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8CAAgB;AAOlB;;AARA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAOlB;;AARA;EACE,eAAgB;AAOlB;;AARA;EACE,eAAgB;EAAhB,YAAgB;AAOlB;;AARA;EACE,WAAgB;AAOlB;;AALE;IACE,gBAAgB;IAChB,mDAAW;IACX,mBAAmB;EACrB;;AAGF;EACE,8CAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AALA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAIlB;;AALA;EACE,eAAgB;AAIlB;;AALA;EACE,eAAgB;EAAhB,YAAgB;AAIlB;;AALA;EACE,WAAgB;AAIlB;;AAEA;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,8CAAgB;AAKlB;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;AANA;EACE,eAAgB;AAKlB;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;AANA;EACE,WAAgB;AAKlB;AAHE;AAHF;IAII,8CAAgB;AAEpB;AANA;IAII,WAAgB;IAAhB,kBAAgB;IAAhB,WAAgB;AAEpB;AANA;IAII,eAAgB;AAEpB;AANA;IAII,eAAgB;IAAhB,YAAgB;AAEpB;AANA;IAII,WAAgB;AAEpB;EADE;;AAGF;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;AAMA;;AAHE;IACE,mBAAmB;EACrB;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE;2BACyB;EACzB,WAAW;EACX,8BAA8B;AAChC;;AAGE;IACE,gBAAgB;IAChB,mDAAe;IACf,gFAA4C;IAC5C,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;;AACA;IACE,oCAAoC;EACtC;;AAGF;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;AAKA;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,gBAAgB;AAKlB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;AACf;;AAEA;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mDAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;AAUhB;;AARE;IACE,kBAAkB;EACpB;;AAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAwB7B;;AAtBE;IACE,eAAe;IACf,gBAAgB;EAalB;;AAXE;MACE,wBAAwB;IAC1B;;AAEA;MACE,2BAA2B;IAC7B;;AAEA;MACE,eAAe;IACjB;;AAGF;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;EAC1B;;AAGF;EACE,kBAAkB;AA4DpB;;AA1DE;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EAarB;;AAXE;MACE,YAAY;MACZ,mBAAmB;MACnB,mDAAa;IACf;;AACA;MACE,YAAY;MACZ,gBAAgB;MAChB,yBAAiB;cAAjB,iBAAiB;MACjB,wBAAwB;IAC1B;;AAGF;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;EACX;;AAEA;IACE,kBAAkB;EACpB;;AAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;AAEA;IACE,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;AAEA;IACE,8DAAwB;IACxB,gBAAgB;EAClB;;AAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;IAC3B,mDAAa;IACb,qCAAqC;EACvC;;AAGF;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,yEAAwC;EACxC,yBAAyB;EACzB,WAAW;AAIb;;AAHE;IACE,8BAA8B;EAChC;;AAGF;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAGE,yCAAyC;;AAEzC;IACE,eAAe;EACjB;;AAGF;EACE,aAAa;EACb,QAAQ;AAKV;;AAJE;IACE,WAAW;IACX,kBAAkB;EACpB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8DAAuB;AACzB;;AAEA;;EAEE,8DAAuB;AACzB;;AAEA;;EAEE,8DAAuB;AACzB;;AAEA;EACE,8DAAuB;AACzB;;AAEA;EACE,8DAAuB;AACzB;;AAEA;EACE,8DAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mDAAa;EACb,6BAAqB;EAArB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mDAAiB;EACjB,kCAA0B;EAA1B,0BAA0B;AAC5B","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDull, gtBlueDark, gtRed, gtGrayLight, gtGray, text, gtCyanDark,textGray from colors;\n\n.distributionHeaderWrapper {\n  background-color: gtBlueDull;\n}\n\n.distributionHeader {\n  composes: content-container from helpers;\n  display: flex;\n  position: relative;\n  flex-direction: row;\n}\n\n.distributionHeaderLeft {\n  lost-column: 3/4;\n\n  .drfHeader {\n    font-weight: 600;\n    color: text;\n    margin-bottom: 32px;\n  }\n}\n\n.distributionHeaderRight {\n  lost-column: 1/4;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n\n.section {\n  composes: boxWrap from helpers;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.sectionTitle {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.sectionSubtitle {\n  margin-top: 0;\n}\n\n/* BTE note: I don't know why this works but...CSS is weird. */\n.fullScreen {\n  lost-column: 3/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1/1;\n  }\n}\n\n.tableContainer {\n  width: 100%;\n  margin-top: 0px;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.select {\n  composes: select from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.tabsContainer {\n  /* display: flex;\n  flex-direction: column; */\n  width: 100%;\n  background-color: antiquewhite;\n}\n\n:global {\n  .react-tabs__tab--selected {\n    font-weight: 600;\n    color: textGray;\n    border-bottom: 3px solid textGray !important;\n    margin-bottom: -3px;\n    text-transform: uppercase;\n  }\n\n  .react-tabs__tab {\n    opacity: 1;\n    height: 50px;\n    cursor: pointer;\n    padding: 16px 10px;\n    text-transform: uppercase;\n    font-size: 14px;\n  }\n  .react-tabs__capitalize {\n    text-transform: uppercase !important;\n  }\n}\n\n.tabList {\n  color: textLight;\n  height: 100%;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-flow: wrap;\n  list-style: none;\n  border-bottom: 1px solid borderColor;\n  margin: 1px 0 0 0;\n  padding: 0;\n  position: relative;\n  z-index: 10;\n}\n\n.button {\n  composes: button from helpers;\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal {\n  margin-left: 8px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal.disabled {\n  display: none;\n}\n\n.newRequestButton {\n  composes: button from helpers;\n  width: 100%;\n  text-align: left;\n}\n\n.headerDay {\n  margin-top: 28px;\n  color: gtBlue;\n  margin-bottom: 0;\n  font-weight: 300;\n}\n\n.headerDate {\n  color: gtBlue;\n  font-weight: 700;\n}\n\n.summaryBoxContainer {\n  margin-top: 36px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.summaryBox {\n  padding-left: 16px;\n  margin-right: 16px;\n  border-left: 1px solid rgba(128, 128, 128, 0.5);\n  color: #31333f;\n\n  .summaryBoxTitle {\n    margin-bottom: 4px;\n  }\n\n  .summaryBoxCaption {\n    margin: -4px 0 0 0;\n    font-size: 10px;\n  }\n}\n\n.distributionHeaderNav {\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0 !important;\n\n  .navItem {\n    font-size: 15px;\n    font-weight: 500;\n\n    &:first-child {\n      padding: 16px 25px 6px 0;\n    }\n\n    &:not(:first-child) {\n      padding: 16px 25px 6px 25px;\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .navItemActive {\n    margin-top: 1px;\n    font-weight: 700;\n    border-bottom: 3px solid;\n  }\n}\n\n.tableFilter {\n  padding: 24px 18px;\n\n  .tableSelectFilter {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: row;\n\n    .tableSelect {\n      width: 220px;\n      margin-bottom: 12px;\n      color: gtGray;\n    }\n    p {\n      color: white;\n      font-weight: 600;\n      user-select: none;\n      margin-top: 0 !important;\n    }\n  }\n\n  .checkboxGroup {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .checkboxGroup > div {\n    margin-bottom: 5px;\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n    left: -9999em;\n  }\n\n  label {\n    display: block;\n    padding: 6px 10px;\n    box-sizing: border-box;\n    border: 1px solid inherit;\n    border-radius: 5px;\n    background-color: transparent;\n    font-size: 14px;\n    cursor: pointer;\n    position: relative;\n  }\n\n  .checkboxActive label {\n    background-color: gtGray;\n    font-weight: 700;\n  }\n\n  .checkboxActiveInactive label {\n    border: 1px solid;\n    background-color: transparent;\n    /* Red for inactive state */\n    color: gtGray;\n    /* White text for better visibility */\n  }\n}\n\n.tableHeader {\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 500;\n  padding-bottom: 6px !important;\n  padding-top: 18px !important;\n  background-color: gtGrayLight !important;\n  color: #31333f !important;\n  width: auto;\n  span {\n    align-items: center !important;\n  }\n}\n\n.cellNoPadding {\n  padding-right: 0 !important;\n  width: 24px;\n}\n\n.formItemMono {\n  /* composes: formItemMono from helpers; */\n\n  label {\n    font-size: 12px;\n  }\n}\n\n.drfSearch {\n  display: flex;\n  gap: 6px;\n  .textInput {\n    width: 100%;\n    padding-left: 24px;\n  }\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.logo {\n  height: 24px;\n  width: 24px;\n}\n\n.closingRow {\n  color: gtRed !important;\n}\n\n.closingRow .tdCell,\n.closingRow.tdRow {\n  color: gtRed !important;\n}\n\n.closingRow .tdCell span,\n.closingRow span {\n  color: gtRed !important;\n}\n\na.closingRow {\n  color: gtRed !important;\n}\n\na.closingRow .tdCell {\n  color: gtRed !important;\n}\n\na.closingRow .tdCell span {\n  color: gtRed !important;\n}\n\n.exportLinkContainer {\n  padding: 12px 16px;\n  text-align: right;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.exportLink {\n  background: none;\n  border: none;\n  color: gtBlue;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  padding: 8px;\n  margin-left: auto;\n  margin-right: 16px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.exportLink:hover {\n  color: gtBlueDark;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDull": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDull"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"gtCyanDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCyanDark"]}`,
	"textGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textGray"]}`,
	"distributionHeaderWrapper": `styles__distributionHeaderWrapper___pJDmw`,
	"distributionHeader": `styles__distributionHeader___S7N4V ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"distributionHeaderLeft": `styles__distributionHeaderLeft___fAOYJ`,
	"drfHeader": `styles__drfHeader___bHz5a`,
	"distributionHeaderRight": `styles__distributionHeaderRight___n0Rqk`,
	"contentContainer": `styles__contentContainer___s91oN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"section": `styles__section___auDdN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]}`,
	"sectionTitle": `styles__sectionTitle___Z8ObV`,
	"sectionSubtitle": `styles__sectionSubtitle___nlm_Y`,
	"fullScreen": `styles__fullScreen___BOMKu`,
	"tableContainer": `styles__tableContainer___KqSjd`,
	"sectionNoMargin": `styles__sectionNoMargin___bfeGn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"input": `styles__input___DI2pD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"select": `styles__select___IO5mK ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"label": `styles__label___bvoMI ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"tabsContainer": `styles__tabsContainer___Mz5q3`,
	"tabList": `styles__tabList___cNOf9`,
	"button": `styles__button___a55jA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___igIw6`,
	"disabled": `styles__disabled___RyW69`,
	"newRequestButton": `styles__newRequestButton____kD85 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"headerDay": `styles__headerDay___Hjv37`,
	"headerDate": `styles__headerDate___pL9OI`,
	"summaryBoxContainer": `styles__summaryBoxContainer___cgT8m`,
	"summaryBox": `styles__summaryBox___NVDJZ`,
	"summaryBoxTitle": `styles__summaryBoxTitle___Whci6`,
	"summaryBoxCaption": `styles__summaryBoxCaption___IqiJB`,
	"distributionHeaderNav": `styles__distributionHeaderNav___Aaw_G`,
	"navItem": `styles__navItem___dZBpZ`,
	"navItemActive": `styles__navItemActive___zsGun`,
	"tableFilter": `styles__tableFilter___KfGrz`,
	"tableSelectFilter": `styles__tableSelectFilter___HAwoo`,
	"tableSelect": `styles__tableSelect___Xtz0Y`,
	"checkboxGroup": `styles__checkboxGroup___EVuBT`,
	"checkboxActive": `styles__checkboxActive___mhYk0`,
	"checkboxActiveInactive": `styles__checkboxActiveInactive___HimYq`,
	"tableHeader": `styles__tableHeader___ik3WO`,
	"cellNoPadding": `styles__cellNoPadding___VnitR`,
	"formItemMono": `styles__formItemMono___mGC9T`,
	"drfSearch": `styles__drfSearch___sotEN`,
	"textInput": `styles__textInput___oV_xv`,
	"capitalize": `styles__capitalize___xheWF`,
	"logo": `styles__logo___mIZlx`,
	"closingRow": `styles__closingRow___jZTnV`,
	"tdCell": `styles__tdCell___APNy0`,
	"tdRow": `styles__tdRow___AHnOw`,
	"exportLinkContainer": `styles__exportLinkContainer___O64sG`,
	"exportLink": `styles__exportLink___LdBwA`
};
export default ___CSS_LOADER_EXPORT___;
